import { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';
import Info from '../../Info';
import DropdownClassic from "../../../components/DropdownClassic"
import DoughnutChart from "../../../charts/DoughnutChart"

// Import utilities
import { tailwindConfig } from '../../../utils/Utils';

function PieCard({title, category, data, hint, filterFunc}) {

  const bg_colors = ['#fdcc52', '#f7699f', '#5D4954', '#2E4057', '#4FD1C5', '#66A9F7']
  const hover_bg_colors = ['#FAB403', '#F3156A', '#473840', '#223041', '#319795', '#0070F4']


  const [chartData, setChartData] = useState(null)

  useEffect(() => {
    if(data.hasOwnProperty('labels') && data.hasOwnProperty('data'))
      setChartData({
        labels: data.labels,
        datasets: [
          {
            label: category,
            data: data.data,
            backgroundColor: bg_colors.slice(0, data.labels.length),
            hoverBackgroundColor: hover_bg_colors.slice(0, data.labels.length),
            hoverBorderColor: '#fff',
          },
        ],
      })
  }, [data]);

  return (
    <div className="bg-white p-5 shadow-1 rounded-sm border border-slate-200 w-full">
      <header className="px-5 py-4 border-b border-slate-100 flex items-center">
        <h2 className="font-semibold text-slate-800">{title}</h2>
        <Info className="ml-auto" containerClassName="min-w-80">
          <div className="text-sm">{hint}</div>
        </Info>
      </header>
      <div className="flex p-3 justify-center">
        <div className="flex flex-col h-full">
          {/* Card content */}
          <div className="grow">
            {/* Chart built with Chart.js 3 */}
            {/* Change the height attribute to adjust the chart height */}
            {chartData!=null?
              <DoughnutChart data={chartData} width={100} height={125}
                             filterFunc={filterFunc} category={category}/>:
              <div className="sm:flex justify-items-center w-full mt-4">
                <div className="m-auto text-center">
                  <svg className="animate-spin h-5 w-full" viewBox="0 0 100 100">
                    <circle cx="50" cy="50" r="45" stroke="#F7699F" strokeWidth="6" fill="transparent" strokeLinecap="round"
                            strokeDasharray="283" strokeDashoffset="75"/>
                  </svg>
                </div>
              </div>}
          </div>
        </div>
      </div>
    </div>
  );
}

export default PieCard;
